import useRestaurantMapsWithTables from "../queries/restaurantMap/useRestaurantWithTables";
import { RestaurantTable } from "../utils/interfaces";

const useRestaurantTables = () => {
  const { data } = useRestaurantMapsWithTables();
  return data?.flatMap((map) =>
    map.tables.map((table) => ({ ...table, mapId: map.item_id }))
  ) as RestaurantTable[];
};

export default useRestaurantTables;
